
window.styleToggle = {

	local : null,
	array : [], 

	onInit( elem ){

		this.local  = !elem ? document.querySelector('.c-local') : elem;
		this.wrap   = this.local.querySelectorAll('.js-tgl');
		if( this.wrap ){
			for (let i = 0; i < this.wrap.length; i++) {
				const wrap = this.wrap[i];
				this.array.push({
					isopened : false,
					wrap     : wrap,
					target   : wrap.querySelector('.js-tgl-target'),
					click    : {
						el : wrap.querySelector('.js-tgl-a'),
						func : null,
						event : null
					}
				});
			}
			this.addEvents();
		}

	},

	addEvents(){
		this.array.forEach( (v,i) =>{
			v.click.func = (e) => {
				e.preventDefault();
				v.wrap.classList.toggle('is-o');
			}
			v.click.event = v.click.el.addEventListener('click', v.click.func );
		});
	},

	onDestroy(){
		this.array.forEach( (v,i) =>{
			v.click.el.removeEventListener('click', v.click.func );
			v.click.func = null;
		});
		this.array = [];
	}

}



window.styleMenu = {
	isopened : false,
	once( elem ){
		this.a = document.querySelector('.js-tgl-menu');
		this.a.addEventListener('click' , e =>{
			e.preventDefault();
			if( !this.isopened ){
				this.onOpen();
			} else {
				this.onClose();
			}
		});
	},
	onOpen(){
		this.isopened = true;
		$html.classList.add('is-o-mu');
	},
	onClose(){
		this.isopened = false;
		$html.classList.remove('is-o-mu');
	}
}
styleMenu.once();

























